module.exports = __webpack_public_path__ + "img/4.9cb277f3.png";